import { Injectable } from '@angular/core';
import { RestService } from './rest-service';
import { IManagerResponse } from 'src/app/core/models/i-manager-response';
import { Observable } from 'rxjs';
import { IManager } from 'src/app/core/models/i-manager';
import { ISector } from 'src/app/core/models/i-sector';
import {
  NO_SECTORS_SELECTED,
  ALL_SECTORS_SELECTED,
} from 'src/app/shared-form-sections/components/related-manager-item/constants/sectors';
import { IRelatedManager } from 'src/app/core/models/i-related-manager';
import { IManagerDashboardResponse } from 'src/app/core/models/i-manager-dashboard-response';
import { IManagerProfileResponse } from 'src/app/core/models/i-manager-profile-response';
import { IManagerProfile } from 'src/app/core/models/i-manager-profile';

@Injectable({
  providedIn: 'root',
})
export class ManagerService {
  static readonly ENTITY_IDENTIFIER: string = 'managers';
  private readonly BASE_MANAGER_ROUTE = `api/${ManagerService.ENTITY_IDENTIFIER}`;
  private readonly BUILD_HTTP_ROUTE = (...args) =>
    this.restService.BUILD_HTTP_ROUTE(this.BASE_MANAGER_ROUTE, ...args);

  constructor(private restService: RestService) {}

  getManagerById$(id: number): Observable<IManagerResponse> {
    return this.restService.get$<IManagerResponse>(this.BUILD_HTTP_ROUTE(id));
  }

  getManagerProfileById$(id: number): Observable<IManagerProfileResponse> {
    return this.restService.get$<IManagerProfileResponse>(
      this.BUILD_HTTP_ROUTE('profiles/' + id)
    );
  }

  getAllManagerProfiles$(pageNumber: number, pageSize: number) {
    const params = this.restService.buildParamsObjectWithPaging(
      {},
      pageNumber,
      pageSize
    );

    return this.restService.get$<IManagerDashboardResponse>(
      this.BUILD_HTTP_ROUTE('profiles'),
      {
        params,
      }
    );
  }

  createManagerProfile$(request: IManagerProfile) {
    return this.restService.post$(this.BUILD_HTTP_ROUTE('profiles'), request);
  }

  mapRelatedManagersToManager(relatedManagers: IRelatedManager[]): IManager[] {
    return relatedManagers
      .filter((relatedManager) => relatedManager?.manager)
      .map((relatedManager) =>
        this.buildManager(relatedManager.manager, relatedManager.selectedSector)
      );
  }

  buildManager(manager: IManager, sector: ISector): IManager {
    if (sector) {
      switch (sector) {
        case NO_SECTORS_SELECTED: {
          manager.hasNoSectorsSelected = true;
          manager.selectedSector = null;
          break;
        }
        case ALL_SECTORS_SELECTED: {
          manager.hasNoSectorsSelected = false;
          manager.selectedSector = null;
          break;
        }
        default: {
          manager.hasNoSectorsSelected = false;
          manager.selectedSector = sector;
          break;
        }
      }
    }
    return manager;
  }
}
